import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { BpAnswers, configureBoldPenguinButton } from '@boldpenguin/agent-quote-start';

import withErrorHandler from '../../hoc/with-error-handler';
import axios from '../../shared/axios';

import { getQuoteApplicationData } from './store/actions';

import './styles.less';
import { AppDispatch } from '../../store';

export type BoldPenguinQuotationComponentProps = {};

export type BoldPenguinQuotationComponentParams = {
  env: string;
  buttonClassName: string;
  buttonText: string;
  quoteApplicationId: string;
  bpApplicationId: string;
};

const BoldPenguinQuotationComponent = (props: BoldPenguinQuotationComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const componentParams: BoldPenguinQuotationComponentParams = {
    env: (window as any)['ncBoldPenguinQuotation']['env'],
    buttonClassName: (window as any)['ncBoldPenguinQuotation']['buttonClassName'],
    buttonText: (window as any)['ncBoldPenguinQuotation']['buttonText'],
    quoteApplicationId: (window as any)['ncBoldPenguinQuotation']['quoteApplicationId'],
    bpApplicationId: (window as any)['ncBoldPenguinQuotation']['bpApplicationId'],
  };

  useEffect(() => {
    configureBoldPenguinButton({
      appName: 'NowCerts',
      env: componentParams.env === 'test' ? 'beta' : '',
      customStyles: componentParams.buttonClassName ? true : false,
      getAnswers: async (sourceId): Promise<BpAnswers> => {
        const quoteAppData = await dispatch(getQuoteApplicationData(sourceId));

        return quoteAppData as BpAnswers;
      },
      onSuccess: (sourceId, bpApplicationId) => {
        // dispatch(saveBoldPenguinApplicationId(sourceId, bpApplicationId));
      },
    });
  }, []);

  const buttonClassName = componentParams.buttonClassName
    ? componentParams.buttonClassName
    : 'boldpenguin-aqs-button boldpenguin-aqs-button-nc-custom';

  return (
    <div>
      <button
        id="btnBoldPenguin"
        type="button"
        className={buttonClassName}
        data-source-id={componentParams.quoteApplicationId}
        data-bp-id={componentParams.bpApplicationId}
      >
        {componentParams.buttonText}
      </button>
    </div>
  );
};

export default withErrorHandler(BoldPenguinQuotationComponent, axios);
